import Hero from "@/components/landing/Hero";
import WhatIDo from "@/components/landing/WhatIDo";
import HowItWorks from "@/components/landing/HowItWorks";
import WhoThisIsFor from "@/components/landing/WhoThisIsFor";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingCTA from "@/components/landing/FloatingCTA";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative overflow-x-hidden">
      <Hero />
      <WhatIDo />
      <HowItWorks />
      <WhoThisIsFor />
      <Testimonials />
      <Contact />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
